import React from "react"
//import "../HomePage/HomePlateform.css"
import "./ToolBoxButton.css"

const ToolBoxButton = (props) => {
    const { icon, caption, url } = props;

    return (
        <div className={`button-container ${props.class ? props.class : ""}`}>
            <a className="button-link" href={url} target="_blank" rel="noopener noreferrer">
                {icon && (
                    typeof icon === "string" ? (
                        <img className="toolbox-icon" src={icon} alt="" aria-hidden="true" />
                    ) : (
                        <span className="toolbox-icon">{icon}</span>
                    )
                )}
                <span className="button-caption" title={caption}>{caption}</span>
            </a>

            <div
                style={{
                    color: `${props.color || "green"}`,
                    fontSize: "14px",
                }}
                className="toolbox-hint"
                dangerouslySetInnerHTML={{ __html: props.text }}
            />
        </div>
    );
}

export default ToolBoxButton